import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-36a16de2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-nav-top"
};
var _hoisted_2 = {
  class: "page-content"
};
var _hoisted_3 = {
  class: "page-footer"
};
// eslint-disable-next-line no-undef
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    className: {
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var className = props.className;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(className))
      }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "nav")]), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "content")]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer")])], 2);
    };
  }
});